import HomeVisual from './components/home-visual/home-visual'
import Header from './components/header/header'
import './style/app.css'
import Footer from './components/footer/footer'
import About from './components/about/about'
import Projects from './components/projects/projects'

const App = () => {
  return (
    <>
      <Header/>
      <HomeVisual/>
      <About/>
      <Projects/>
      <Footer/>
    </>
  );
}

export default App;
